import {
    apiRequest,
    skcpnsUpdate
} from '../../../../../services/adapters/kepegawaian/skcpnsService'

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", skcpnsUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository